import { AccordionContainer } from "../../../../../common/components/accordion/accordion.module"
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container"
import { InputLabelContainer } from "../../../../../common/components/form/label/containers/input-label.container"


export const DbaMappingBasicInfoComponent = ({dodProgramParticipants,channelPrograms,dbas,dbnps, id,onFormChange, dbnp, selectedDbaMapping, fetchDbnpList }: any) => {
     const upstreamProvider: any = [
    { Description: 'Brand Catalog', Value: 10 },
    { Description: 'Partner Catalog', Value: 20 },
    { Description: 'Hybrid Catalog', Value: 30 },
  ]

    const catalogType: any = [
    { Description: 'B2B', Value: 10 },
    { Description: 'B2C', Value: 20 },
      ]
    return (<>
 <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         {id === '0' &&
          <InputContainer
              label="Internal DBNP"
              labelField="Name"
              list={dbnps}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'InternalDBNPId'
                )
              }}
              optionName='Choose ConsumerDBNP'
              type="select"
              value={selectedDbaMapping?.InternalDBNPId}
              valueField="Id"
          />}
         {id === '0' &&
          <InputContainer
              label="Partner DBNP"
              labelField="name_of_authorised_signatory"
              list={dbnp}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'PartnerDBNPRegistryId'
                )
              }}
              optionName='Choose Partner DBNP'
              type="select"
              value={selectedDbaMapping?.PartnerDBNPRegistryId}
              valueField="Id"
          />}
  {id === '0' &&
          <InputContainer
              label="Partner DBA"
              labelField="Name"
              list={dbas}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'PartnerGlobalDBARegistryId'
                )
              }}
              optionName='Choose Partner DBA'
              type="select"
              value={selectedDbaMapping?.PartnerGlobalDBARegistryId}
              valueField="GlobalDBARegistryId"
          />}
         {id !== '0' &&
         <div>
            <InputLabelContainer label="Internal  DBNP" />
            <InputLabelContainer label={selectedDbaMapping?.InternalDBNPName} />
            </div>}
            {id !== '0' &&
         <div>
            <InputLabelContainer label="Partner DBNP "/>
            <InputLabelContainer label={selectedDbaMapping?.PartnerDBNPName} />
            </div>}
              {id !== '0' &&
         <div>
            <InputLabelContainer label="Partner DBA"/>
            <InputLabelContainer label={selectedDbaMapping?.PartnerGlobalDBARegistryName} />
            </div>}
            </div>

           }
     expandedPanel="basicInfo"
     headerTitle="Basic Info"
 /> 
  <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer
    label="Upstream Provider"
    name="IsUpstreamProvider"
    onValueChange={(event: any) => {
      onFormChange(
        event,
        'IsUpstreamProvider'
      )
    }}
    type="checkbox"
    value={selectedDbaMapping?.IsUpstreamProvider}
/>
  {selectedDbaMapping?.IsUpstreamProvider &&

    <InputContainer
              label="UpStream Provider Name" 
              labelField="Description"
              list={upstreamProvider}
              onValueChange={(newValue: any) => {
                const countryData: any = newValue.map((option: any) => option?.value || '')
  
                 onFormChange(
                  countryData,
                  'UpstreamProviderIds'
                )
              }}
              type="multiselect"
              valueField="Value"
              value={selectedDbaMapping?.UpstreamProviderIds}
          />
   
        }
</div>
  }
     expandedPanel="UpStream Provider Info"
     headerTitle="UpStream Provider Info"
 />

   <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
   <InputContainer
              label="Channel Provider"
              name="IsChannelProvider"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'IsChannelProvider'
                )
              }}
              type="checkbox"
              value={selectedDbaMapping?.IsChannelProvider}
          />
            {selectedDbaMapping?.IsChannelProvider &&
    <InputContainer
              label="Channel Provider Name"
              labelField="Name"
              list={channelPrograms}
              onValueChange={(newValue: any) => {
                const countryData: any = newValue.map((option: any) => option?.value || '')
  
                 onFormChange(
                  countryData,
                  'GlobalChannelShipXProgramIds'
                )
              }}
              type="multiselect"
              value={selectedDbaMapping?.GlobalChannelShipXProgramIds}
              valueField="GlobalChannelProgramId"
          />
        }
    </div>

  }
     expandedPanel="Channel Provider Info"
     headerTitle="Channel Provider Info"
 />
    <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

   <InputContainer
              label="ShipX Program Participant" 
              labelField="Name"
              list={dodProgramParticipants}
               onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'GlobalShipXProgramParticipantId'
                )
              }}
              optionName='Choose ShipX Program Participant'
               type="select"
              valueField="Id"
              value={selectedDbaMapping?.GlobalShipXProgramParticipantId}
          />

         <InputContainer
              label="ShipX Program Participant Type" 
              labelField="Description"
              list={catalogType}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'GlobalShipXProgramParticipantType'
                )
              }}
              optionName='Choose ShipX Program Participant Type'
               type="select"
              valueField="Description"
              value={selectedDbaMapping?.GlobalShipXProgramParticipantType}
          />   
   
        
</div>
  }
     expandedPanel="ShipX Program Participant Info"
     headerTitle="ShipX Program Participant Info"
 />     

     {id !== '0' &&
  <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        
            <InputContainer
    label="Active"
    name="IsActive"
    onValueChange={(event: any) => {
      onFormChange(
        event,
        'IsActive'
      )
    }}
    type="checkbox"
    value={selectedDbaMapping?.IsActive}
/>

</div>

          }
     expandedPanel="Disable Mappings"
     headerTitle="Disable mappings"
 />
        }
        </>
)}
export default DbaMappingBasicInfoComponent;
